import { PortfolioType } from "lib/types";
import SponsoredBanner from "./SponsoredBanner";
import UnsponsoredBanner from "./UnsponsoredBanner";

interface Props {
  portfolio: PortfolioType;
  sponsored: boolean;
  type: string;
  category: string;
  scheme_sponsored: boolean;
  resultId: number;
}

const Sponsored = ({sponsored,portfolio,type,category, scheme_sponsored, resultId}:Props) => {
    if(sponsored === false || scheme_sponsored  === false) {
       return null
    }

    if(!portfolio?.id || !portfolio.sponsored) return null;

    const logo = portfolio.active && portfolio.advertise && portfolio.sponsored  ? `/images/portfolios/${portfolio.uri.toLowerCase()}/logo.svg` : `${process.env.NEXT_PUBLIC_APP_MEDIA_URL}${portfolio.logo_uri}`

    return (
        <SponsoredBanner id={portfolio.id} resultId={resultId} dark={portfolio?.styles?.dark} name={portfolio.name} url={portfolio.url}  logo_uri={logo} />
    )
};

export default Sponsored;

